<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item>同步数据</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button type="primary" class="editbtn" @click="get_all_shopline_products()">获取所有的shopline商品</el-button>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="180px">
          <el-form-item label="平台">
            <el-select
              v-model="form.platform_code"
              placeholder="Select"
            >
              <el-option label="SHOPLINE" :value="10016">SHOPLINE</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领星店铺">
            <el-select
              v-model="form.store_id"
              placeholder="Select"
              @change="get_info()"
            >
              <el-option
                v-for="item in baseData.sellerList"
                :key="item.store_id"
                :label="item.store_name"
                :value="item.store_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="shopline分类">
            <el-radio-group v-model="baseData.shopline_cate_type" @change="canclecateid()">
                <el-radio value="1" label="1">手动分类</el-radio>
                <el-radio value="2" label="2">智能分类</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手动分类" v-if="baseData.shopline_cate_type=='1'">
            <el-select
              v-model="form.shopline_cate_id"
              placeholder="Select"
              multiple
              filterable
            >
              <el-option
                v-for="item in baseData.shopline_custom_collections"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="智能分类" v-if="baseData.shopline_cate_type=='2'">
            <el-select
              v-model="form.shopline_cate_id"
              placeholder="Select"
              multiple
              filterable
            >
              <el-option
                v-for="item in baseData.shopline_smart_collections"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="shopline地点">
            <el-select
              v-model="form.locations_id"
              placeholder="Select"
              multiple
              filterable
            >
              <el-option
                v-for="item in baseData.locations_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="领星仓库">
            <el-cascader v-model="baseData.choosewarehouselist" :options="baseData.warehouselist" :props="props" @change="choosewids()"/>
          </el-form-item> -->
          
          <el-form-item label="库存">
            <el-table v-loading="baseData.loading" border :data="tableData.data" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" label="同步" width="55"></el-table-column>
                <el-table-column prop="cate_name" label="shopline分类"></el-table-column>
                <el-table-column prop="sku" label="sku"></el-table-column>
                <el-table-column prop="msku" label="msku"></el-table-column>
                <el-table-column prop="store_name" label="店铺"></el-table-column>
                <el-table-column prop="locations_name" label="地点"></el-table-column>
                <el-table-column prop="warehouse" label="配对仓库"></el-table-column>
                <el-table-column prop="product_valid_num" label="总领星库存" width="100"></el-table-column>
                <el-table-column prop="inventory_quantity" label="shopline后台库存" width="160"></el-table-column>
                <el-table-column prop="value" label="差异" width="80"></el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="get_all_warehouse_products_list">获取库存</el-button>
            <el-button type="success" @click="update_shopline_products_available">更新shopline库存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading } from 'element-plus'
  const searchForm = reactive({
      limit:10,
      page:1,
  })
  const form:any = reactive({
    store_id:"",
    locations_id:[],
    platform_code:10016,
    warehouse: [],
    warehouse_list: [],
    shopline_cate_id:[],
  })
  const baseData = reactive({
    sellerList:{},
    warehouselist:[],
    choosewarehouselist:[],
    shopline_cate_type:"1",
    shopline_custom_collections:[],
    shopline_smart_collections:[],
    locations_list:[],
    loading:false,
    chooseTableData:[],
  })
  const tableData:any = reactive({
      data:[],
      total:0,
  })
  const canclecateid = () => {
    form.shopline_cate_id = []
  }
  const props = {
    expandTrigger: 'hover' as const,
    multiple:true,
    label:'name',
    value:'wid',
  }
  const handleSelectionChange = (val:any) => {
    baseData.chooseTableData = val
    console.log(val,9999)
  }
  const update_shopline_products_available = () => { 
    const loading = ElLoading.service({lock: true})
    api.accessoryApi.update_shopline_products_available({data:baseData.chooseTableData}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        let tabledata = tableData.data, inventory_item_ids = res.data
        tabledata.forEach(element => {
          for(let i in inventory_item_ids){
            if(element.inventory_item_id == inventory_item_ids[i].inventory_item_id && element.location_id == inventory_item_ids[i].location_id){
              element.inventory_quantity = inventory_item_ids[i].available
              element.value = 0
            }
          }
        });
        tableData.data = tabledata
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const choosewids = () => {
    let wids:any = [], warehouse:any = [], warehouselist:any = baseData.warehouselist, newwarehouselist = [];
    baseData.choosewarehouselist.forEach(element => {
      wids.push(element[1])
      if(element[0] == 3){
        newwarehouselist = warehouselist[1]
        for(let i in newwarehouselist.children){
          if(newwarehouselist.children[i].wid == element[1]){
            warehouse.push({wid : newwarehouselist.children[i].wid,name : newwarehouselist.children[i].name})
          }
        }
      }else if(element[0] == 1){
        newwarehouselist = warehouselist[0]
        for(let i in newwarehouselist.children){
          if(newwarehouselist.children[i].wid == element[1]){
            warehouse.push({wid : newwarehouselist.children[i].wid,name : newwarehouselist.children[i].name})
          }
        }
      }
    });
    form.warehouse = wids
    form.warehouse_list = warehouse
  }
  const get_all_shopline_products = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.get_all_shopline_products().then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }

  const get_locations_list = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.locations_list({seller_id:form.store_id}).then((res:any)=>{
      if(res.code==200){
        baseData.locations_list = res.data.locations
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_custom_collections = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.get_custom_collections({seller_id:form.store_id}).then((res:any)=>{
      if(res.code==200){
        baseData.shopline_custom_collections = res.data.custom_collections
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_smart_collections = () => {
    const loading = ElLoading.service({lock: true})
    api.shoplineApi.get_smart_collections({seller_id:form.store_id}).then((res:any)=>{
      if(res.code==200){
        baseData.shopline_smart_collections = res.data.smart_collections
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_warehouse = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.get_warehouse().then((res:any)=>{
      if(res.code==200){
        baseData.warehouselist = res.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getSellerList = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.getSellerList({platform_code:form.platform_code}).then((res:any)=>{
      if(res.code==200){
        baseData.sellerList = res.data.list
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const get_all_warehouse_products_list = () => {
    baseData.loading = true
    let shopline_cate_list = [], warehouse_list = []
    if(baseData.shopline_cate_type == "1"){
        let shopline_custom_collections:any = baseData.shopline_custom_collections
        for(var i in shopline_custom_collections){
            for(var j in form.shopline_cate_id){
                if(shopline_custom_collections[i].id == form.shopline_cate_id[j]){
                    shopline_cate_list.push({id : shopline_custom_collections[i].id,title : shopline_custom_collections[i].title})
                }
            }
        }
    }else if(baseData.shopline_cate_type == "2"){
        let shopline_smart_collections:any = baseData.shopline_smart_collections
        for(var w in shopline_smart_collections){
            for(var g in form.shopline_cate_id){
                if(shopline_smart_collections[w].id == form.shopline_cate_id[g]){
                    shopline_cate_list.push({id : shopline_smart_collections[w].id,title : shopline_smart_collections[w].title})
                }
            }
        }
    }
    // let warehouselist:any = baseData.warehouselist
    // for(var x in warehouselist){
    //     for(var t in form.warehouse){
    //         if(warehouselist[x].wid == form.warehouse[t]){
    //             warehouse_list.push({wid : warehouselist[x].wid,name : warehouselist[x].name})
    //         }
    //     }
    // }
  
    api.accessoryApi.get_all_warehouse_products_list({store_id:form.store_id,warehouse_list:form.warehouse_list,shopline_cate_list:shopline_cate_list,shopline_cate_id:form.shopline_cate_id,wids:form.warehouse,locations_id:form.locations_id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
      baseData.loading = false
    })
  }
  const get_info = () => { 
    form.shopline_cate_id = []
    form.locations_id = []
    get_locations_list()
    get_custom_collections()
    get_smart_collections()
  }
  onMounted(() => {
    get_warehouse()
    getSellerList()
    console.log('onMounted')
  })
  </script>